import { useContext } from "react";
import { AllDataContext } from "../../../lib/dataContext";
import { FooterLink, Inner, LinkContainer, DSFooterContainer } from "./styles";

const DSFooter = () => {
  const data = useContext(AllDataContext);

  const links = data.footerItems.footerLinks;

  return (
    <DSFooterContainer>
      <Inner>
        <LinkContainer>
          {links?.map((link) => (
            <FooterLink
              className="p2"
              href={link.href}
              rel="noreferrer noopener"
              target="_blank"
              key={link._key}
            >
              {link.title}
            </FooterLink>
          ))}
        </LinkContainer>
      </Inner>
    </DSFooterContainer>
  );
};

export default DSFooter;
